import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../styles/Login.css';

const Login1 = () => {
     const [userCode, setUserCode] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState('');
     const [loading, setLoading] = useState(false);

     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();

     // The actual login function, separate from the form submit event
     const performLogin = async (user, pass) => {
          setError('');
          setLoading(true);

          try {
               const res = await fetch(`${baseUrl}/login1`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                         user_id: user,
                         password: pass,
                    }),
               });

               const data = await res.json();

               if (data.status) {
                    sessionStorage.setItem('token', data.token);
                    sessionStorage.setItem('user_code', data.user_code);
                    sessionStorage.setItem('user_name', data.user_name);
                    sessionStorage.setItem('user_role', data.role);
                    sessionStorage.setItem('is_radiology_doctor', data.is_radiology_doctor);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('userRole', data.role);

                    const expiryTime = new Date().getTime() + 4 * 60 * 60 * 1000;
                    sessionStorage.setItem('expiry', expiryTime);

                    setTimeout(() => {
                         sessionStorage.clear();
                         navigate('/login');
                    }, 4 * 60 * 60 * 1000);

                    if (data.password === 'default_password') {
                         navigate('/changepassword');
                    } else {
                         navigate('/dashboard');
                    }
               } else {
                    setError(data.message || 'Login failed');
               }
          } catch (err) {
               setError('Something went wrong. Please try again.');
          } finally {
               setLoading(false);
          }
     };

     // handleSubmit for the form submission event
     const handleSubmit = (e) => {
          e.preventDefault();
          performLogin(userCode, password);
     };

     // On mount, check URL params for auto login
     useEffect(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const uid = urlParams.get('uid');
          const pwd = urlParams.get('pwd');

          if (uid && pwd) {
               try {
                    const decodedUid = atob(uid);
                    const decodedPwd = pwd;

                    // Set state
                    setUserCode(decodedUid);
                    setPassword(decodedPwd);

                    // Perform login AFTER states have been set (use setTimeout 0 to ensure update)
                    setTimeout(() => {
                         performLogin(decodedUid, decodedPwd);
                    }, 0);
               } catch (err) {
                    console.error("Invalid Base64 uid:", err);
               }
          }
     }, []);

     return (
          <div className="login-page">
               <Container fluid className="h-100">
                    <Row className="h-100">
                         <Col md={7} className="login-illustration">
                              <div className="illustration-content">
                                   <img
                                        src="/login_internalhrms.jpg"
                                        alt="HR illustration"
                                        className="illust-image"
                                        style={{ width: '100%', borderRadius: '50px' }}
                                   />
                              </div>
                         </Col>
                         <Col md={5} className="login-form-side">
                              <div className="form-container">
                                   <h3 className="brand-title">HRMS</h3>
                                   <Form onSubmit={handleSubmit}>
                                        {error && <div className="text-danger mb-2">{error}</div>}
                                        <Form.Floating className="mb-3">
                                             <Form.Control
                                                  id="floatingUserCode"
                                                  type="text"
                                                  placeholder=" "
                                                  value={userCode}
                                                  onChange={(e) => setUserCode(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingUserCode">User Code</label>
                                        </Form.Floating>
                                        <Form.Floating className="mb-4">
                                             <Form.Control
                                                  id="floatingPassword"
                                                  type="password"
                                                  placeholder=" "
                                                  value={password}
                                                  onChange={(e) => setPassword(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingPassword">Password</label>
                                        </Form.Floating>
                                        <Button variant="dark" type="submit" className="w-100 mb-3" disabled={loading}>
                                             {loading ? 'Logging in...' : 'Login'}
                                        </Button>
                                        <div className="text-center">
                                             <a href="#forgot" className="forgot-link">
                                                  Forgot password?
                                             </a>
                                        </div>
                                   </Form>
                              </div>
                         </Col>
                    </Row>
               </Container>
          </div>
     );
};

export default Login1;
